export const LOGIN = "/sign-in";
// export const REGISTER = '/sign-up';
export const CONFIRM_EMAIL = "/confirm-email";

export const FORGOT_PASSWORD = "/forgot-password";
export const VERIFY_RECOVERY_CODE = "/verify-recovery-code";
export const CREATE_PASSWORD = "/create-password";

export const DASHBOARD = "/dashboard";
export const UNPROCESSED_EMAILS = "/unprocessed-emails";
export const PROCESSED_EMAILS = "/processed-emails";
export const EMAILS_FOR_REVIEW = "/emails-for-review";
export const RESOLVE_MANUALLY = "/emails-for-review/select-application-form";

export const SELECT_APPLICATION_FORM =
  "/emails-for-review/select-application-form";
export const FILL_APPLICATION_FORM = "/emails-for-review/fill-application-form";
export const SELECT_BANK_STATEMENTS =
  "/emails-for-review/select-bank-statements";
export const FIND_ENTITY_ID = "/emails-for-review/find-entity-id";
export const SELECT_AGENT = "/emails-for-review/select-agent";

export const FAILED_EMAILS = "/failed-emails";

export const SETTINGS_PROFILE = "/settings/profile";
export const SETTINGS_LOGS = "/settings/logs";
